import { render } from "./AddLeads.vue?vue&type=template&id=76733da5&scoped=true"
import script from "./AddLeads.vue?vue&type=script&lang=js"
export * from "./AddLeads.vue?vue&type=script&lang=js"

import "./AddLeads.vue?vue&type=style&index=0&id=76733da5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76733da5"]])

export default __exports__